import * as React from 'react'
import {
    Grid,
    Typography,
    List,
    ListItem,
    ListItemText,
    Box,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobile } from '@fortawesome/pro-duotone-svg-icons'

export const StepThree = ({ kedo, state }) => (
    <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 8 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                {kedo.t('Preview')}
            </Typography>
            <Typography variant="body2" color="textSecondary">
                {kedo.t('step_three_description', { ns: 'secureshare' })}
            </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                {kedo.t('Recipients')}
            </Typography>
            <List sx={{ pl: 0 }}>
                {state.contacts.map((r) => (
                    <ListItem
                        key={r.email}
                        sx={{ py: 0.5, px: 0 }}
                        disableGutters
                    >
                        <ListItemText
                            primary={
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                    }}
                                >
                                    {r.email}
                                    {r.mobile && (
                                        <FontAwesomeIcon icon={faMobile} />
                                    )}
                                </Box>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </Grid>
    </Grid>
)
